import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import AnimatedHeading from 'components/animated-heading-diseno-dev'
import { Link } from 'gatsby'


class DeveloperMobile extends React.Component {

  shouldComponentUpdate() {
    return false
  }


  render() {

    const Section = styled.section`
      position: relative;
      overflow: hidden;
      background-color: #000;      
  `

    const AboutCol = styled(Col)`
      display: flex;
      align-items: center;
  `

    const ImageCol = styled(Col)`
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 767px) {
        padding-top: 30px;
        .image-col {
            text-align: center;
        }
    }
  `

    const ImageWrapper = styled.div`
      text-align: center;
      img {
        max-height: 500px;
        max-width: 500px;
        width: 100%;
        height: auto;
      }      
      @media (max-width: 767px) {
        width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
        padding: 0;
        margin: 40px 0;            
        img {
          max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
          width: 100vw;        /* Igual que el viewport */
          height: auto;
          display: block;       /* Asegura que no tenga espacio extra por inline */          
        }        
      }
    `
    const Main = styled.div`
      padding: 100px 0 150px 0;
      background-color: #fff;
      @media (max-width: 767px) {
          padding: 100px 0;
      }
      @media (min-width: 768px) and (max-width: 1500px) {
          padding: 50px 0 100px 0;
      }      
  `

    const Heading2 = styled.h2`
      font-size: 60px;
      line-height: 70px;
      font-family: 'Montserrat', sans-serif;
      color: #1b2a2f;
      font-weight: bold;      
      @media (min-width:768px) and (max-width:1600px) {
        font-size: 60px;
        line-height: 70px;
    }
    @media (max-width:767px) {
        font-size: 30px;
        line-height: 40px;
        text-align: left;
    }
  `

    const Heading3 = styled.h3`
        font-size: 30px;
        line-height: 40px;
        font-family: 'Montserrat', sans-serif;
        font-weight: bold;        
        @media (min-width:768px) and (max-width:1600px) {
          font-size: 30px;
          line-height: 40px;
        }
        @media (max-width:767px) {
          font-size: 20px;
          line-height: 22px;          
        }
     `
     const Heading3a = styled.h3`
        font-size: 60px;
        line-height: 70px;
        font-family: 'Montserrat', sans-serif;
        font-weight: bold;
        @media (min-width:768px) and (max-width:1600px) {
          font-size: 50px;
          line-height: 60px;
        }        
        @media (max-width:767px) {
          font-size: 30px;
          line-height: 40px;          
        }
     `
    const Color = styled.span`
        color: #c1eb18;
        font-size: 75px;
        line-height: 70px;
        font-family: Teko;
        text-transform: uppercase;
        letter-spacing: 2px;
        @media (min-width:768px) and (max-width:1600px) {
          font-size: 80px;
          line-height: 40px;
        }
        @media (max-width:767px) {
          font-size: 50px;
          line-height: 60px;
        }
      `

    const AboutContent = styled.div`
            padding: 0 20%;
            @media (max-width: 500px) {
                padding: 0 5%;
            }
            @media (min-width: 501px) and (max-width:1600px) {
                padding: 0 5%;
                padding-top: 100px;
            }
        `

    const Separator = styled.div`
      height: 5px;
      width: 50px;
      background-color: #c1eb18;
      margin-bottom: 20px;
  `

    const Text = styled.p`
      font-size: 18px;
      font-weight: 300;
      color: #1a1a1a;
`
    const Headinga = styled(Link)`        
        color: #78c91c;
        transition: .5s;
          &:hover {
            color: #000;
            text-decoration: none;
          }
      `
      const Color3 = styled.span`          
          color: #c1eb18;          
        `
        const Heading2b = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin-top: 100px;            
            font-size: 70px;
            line-height: 70px;
            font-family: "Montserrat", sans-serif;
            font-weight: 800;
            color: #000;
            text-transform: uppercase;
            text-align: center;
            @media (max-width:767px) {
                font-size: 35px;
                line-height: 60px;
            }
        `

    return (
      <Section>
        <Main>
          <Row>
            <Col md={12}>
              <Container>
                <AnimatedHeading text="Seguridad Web" />
                <Heading2b>y Cibersegurida<Color3>d</Color3></Heading2b>
              </Container>
            </Col>
            <AboutCol md={6}>
              <Col md={12}>

                <AboutContent>
                  <Heading2>
                    Certificados <Color>SSL</Color>
                  </Heading2>
                  <Separator />
                  <Heading3>
                    Asegure 1 dominio, múltiples dominios, direcciones IP o subdominios ilimitados
                  </Heading3>
                  <Text>
                    Los certificados SSL (Secure Sockets Layer), también conocidos como certificados de servidor
                    seguro, son pequeños archivos de datos que se instalan en un servidor web para establecer
                    una conexión segura cifrada entre el servidor y el navegador del usuario. Estos certificados
                    son esenciales para la seguridad en línea al proteger la información confidencial
                    transmitida entre el navegador del usuario y el servidor web.
                  </Text>
                  <Text>
                    Cuando un usuario visita un sitio web protegido con un certificado SSL, el protocolo
                    SSL/TLS (Transport Layer Security) crea una conexión segura cifrada entre el navegador
                    del usuario y el servidor web.
                  </Text>
                  <Heading3a>
                    <Headinga to="/certificados-ssl">
                      Certificados SSL
                    </Headinga>
                  </Heading3a>
                </AboutContent>

              </Col>
            </AboutCol>
            <ImageCol md={6}>
              <ImageWrapper>

                <GatsbyImage image={this.props.image} alt="Certificados SSL Colombia" sizes="(max-width: 767px) 300px, 500px" />

              </ImageWrapper>
            </ImageCol>
          </Row>
        </Main>
      </Section>
    )
  }

}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      {
        file(relativePath: { eq: "certificados-ssl.png" }) {
          childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
          }
        }
      }
    `}
    render={(data) => {
      const image = getImage(data.file.childImageSharp.gatsbyImageData);
      return <DeveloperMobile image={image} {...props} />;
    }}
  />
);

export default Iconos;
